<template>
	<div class="invoice_body" id="top" :class="isPhone == 'true' ? 'mobile' : ''">
		<head-nav @userInfo="getUserToken"></head-nav>
		<div class="subtit" style="background: #038dd6">
			<img src="@comm/images/document-conversion/ad_2.jpg" height="100%" style="right: 0" class="banner-" />
			<div class="top">
				<div class="top_nav">
					<!-- <div class="subtit-tit">
						<a>
						<img src="@comm/images/document-conversion/logo.svg" />
						<span>OFD云服务</span>
						</a>
                    </div> -->
					<ul>
						<li>
							<a href="http://www.suwell.cn"></a>
						</li>
						<li>
							<span>数科电子发票阅读器 免费下载：</span>
							<div class="li_fonts">
								<a @click="goDown(1)" class="subtit-upload">
									<img src="@comm/images/document-conversion/win.svg" />
									<span>&nbsp;Windows</span>&emsp;
								</a>
							</div>
							<div class="li_fonts">
								<!-- <a class="subtit-upload subtit-ios-handle"> -->
								<a class="subtit-upload subtit-ios-handle">
									<img src="@comm/images/document-conversion/io.svg" />
									<span>&nbsp;App Store</span>&emsp;
								</a>
								<div class="subtit-ios-bar">
									<img src="@comm/images/document-conversion/ios-download.png" />
									<p>扫描二维码</p>
								</div>
							</div>
							<div class="li_fonts">
								<a class="subtit-upload subtit-android-handle">
									<img src="@comm/images/document-conversion/an.svg" />
									<span>&nbsp;Android</span>&emsp;
								</a>
								<div class="subtit-android-bar">
									<img src="@comm/images/document-conversion/android-download.png" />
									<p>扫描二维码</p>
								</div>
							</div>
						</li>
					</ul>
				</div>
				<div class="top_middle">
					<div class="title">数科OFD电子发票支撑平台</div>
					<div class="stitle">OFD电子发票首选平台</div>
				</div>
				<div class="anchor">
					<a @click.prevent="anchor('public')">个人服务</a>
					<a @click.prevent="anchor('business')">企业应用</a>
				</div>
			</div>
			<div class="top_bottom">
				<div class="left">
					<img src="@comm/images/document-conversion/phone.png" />
					<span>电 话：400-677-5005</span>
				</div>
				<div class="left right">
					<img src="@comm/images/document-conversion/mail.png" />
					<span>邮 箱：wps@wps.cn</span>
				</div>
			</div>
		</div>

		<a id="public" name="public" class="zhanwei"></a>
		<div class="public">
			<div class="item">
				<div class="title">个人服务</div>
			</div>
			<div class="item item2">
				<div class="subtit-content">
					<div class="subtit-con">
						<div class="subtit-item">
							<div class="subtit-item-ico">
								<img src="@comm/images/document-conversion/html1.svg" />
							</div>
							<div class="subtit-item-tit">轻松浏览电子发票</div>
							<div class="subtit-item-con">
								<div>提供将电子发票转换成HTML网页格式</div>
								<div>实现跨平台及浏览器无插件阅读</div>
							</div>
						</div>
						<div class="subtit-item">
							<div class="subtit-item-ico">
								<img src="@comm/images/document-conversion/html2.svg" />
							</div>
							<div class="subtit-item-tit">转PDF / 图片</div>
							<div class="subtit-item-con">
								<div>可快速、便捷地将OFD格式的电子发</div>
								<div>票转换为PDF和图片格式</div>
							</div>
						</div>
						<div class="subtit-item">
							<div class="subtit-item-ico">
								<img src="@comm/images/document-conversion/html3.svg" />
							</div>
							<div class="subtit-item-tit">自动验证真伪</div>
							<div class="subtit-item-con">
								<div>打开OFD发票文件，自动验证发票真伪</div>
								<div>可查看验证结果的详细信息</div>
							</div>
						</div>
						<div class="subtit-item">
							<div class="subtit-item-ico">
								<img src="@comm/images/document-conversion/html4.svg" />
							</div>
							<div class="subtit-item-tit">数据提取、灵活利用</div>
							<div class="subtit-item-con">
								<div>可以XML格式提取发票数据</div>
								<div>便于进行统计等多维度的利用</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="item item3">
				<div class="item-down">
					<div class="contain">
						<div class="con-right">
							<div class="valid" v-if="!disabled">
								<span class="valid-note"
									v-if="verifyInfo.result == 0 || (verifyInfo.result >= '0X00000900' && verifyInfo.result <= '0X000009FF')">发票签章有效！</span>
								<span class="valid-note-err" v-else>发票签章无效！</span>
								<img v-if="verifyInfo.result == 0 || (verifyInfo.result >= '0X00000900' && verifyInfo.result <= '0X000009FF')"
									src="@comm/images/document-conversion/ok.svg" class="valid-true-" />
								<span class="valid-true-false"
									v-if="verifyInfo.result != 0 && (verifyInfo.result < '0X00000900' || verifyInfo.result > '0X000009FF')">问题发票</span>
								<a class="detail" @click="viewDetail">查看详情</a>
							</div>
							<div class="down-type">
								<uploader ref="uploader" :options="options" :autoStart="false" @file-added="onFileAdded"
									@files-submitted="onSubmitted" class="uploader-app">
									<div class="btn btn-primary upload_btn" style="position: relative;z-index: 999;"
										v-if="!token" @click.prevent="loginBtn">打开文件</div>
									<uploader-btn id="global-uploader-btn" v-else class="btn btn-primary upload_btn"
										:attrs="attrs" :single="true" ref="uploadBtn">打开文件</uploader-btn>
								</uploader>
								<!-- <input type="button" value="打开文件" id="upload_btn_" /> -->
								<el-button type="primary" :disabled="disabled" :class="{ upload_btn: !disabled }"
									@click="savePdf"> 下载为PDF </el-button>
								<el-button type="primary" :disabled="disabled" :class="{ upload_btn: !disabled }"
									@click="saveJpg"> 下载为图片 </el-button>
								<el-button type="primary" :disabled="disabled" :class="{ upload_btn: !disabled }"
									@click="viewInvoice"> 查看发票数据 </el-button>
							</div>
						</div>
						<div class="con-left" id="dropbox">
							<div class="upload" v-if="!readerUrl && !isUpLoading">
								<!-- <button type="button" class="btn btn-primary" id="upload_btn">点击选择文件</button> -->
								<uploader ref="uploader" :options="options" :autoStart="false" @dragenter="dragenter"
									@file-added="onFileAdded" @files-submitted="onSubmitted" class="uploader-app">
									<uploader-unsupport></uploader-unsupport>
									<uploader-drop>
									<div class="btn btn-primary btn-upLoad"
										v-if="!token" @click.prevent="loginBtn">点击选择文件</div>
									<uploader-btn id="global-uploader-btn" v-else class="btn btn-primary btn-upLoad"
										:attrs="attrs" :single="true" ref="uploadBtn">点击选择文件</uploader-btn>
										<p>点击打开文件，或将文件拖动到这里打开！</p>
									</uploader-drop>
								</uploader>
								
							</div>

							<div class="upload-loading" v-if="isUpLoading">
								<button type="button" class="btn btn-primary" id="upload_btn_loading">
									<img src="@comm/images/document-conversion/loading-blue.gif"
										style="margin-top: -5px; width: 20px; height: 20px" alt="上传中。。。" />
								</button>
								<p>正在打开文件</p>
							</div>
							<div class="reader" v-if="readerUrl">
								<!-- 轻阅读 -->
								<iframe id="web-reader" :src="readerUrl" frameborder="0" allowfullscreen="true"
									ref="iframe"></iframe>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="item4">
				<div class="title">数科电子发票阅读器 免费下载</div>
				<div class="fonts">
					<div class="public-download-handle">
						<div style="text-align: center">
							<img class="public-download-bar1" src="@comm/images/document-conversion/windows.svg" />
						</div>
						<div class="info">Windows</div>
						<div>
							<a @click="goDown(1)" class="public-download">下载</a>
						</div>
					</div>
					<div class="public-download-handle- public-download-handle public-download-handle2">
						<div style="text-align: center">
							<img class="public-download-bar1" src="@comm/images/document-conversion/ios.svg" />
							<img class="public-download-bar2" src="@comm/images/document-conversion/ios-download.png" />
						</div>
						<div class="info">iOS</div>
						<div>
							<a class="public-download">下载</a>
						</div>
					</div>
					<div class="public-download-handle- public-download-handle"
						style="float: left; width: 120px; cursor: pointer">
						<div style="text-align: center">
							<img class="public-download-bar1" src="@comm/images/document-conversion/android.svg" />
							<img class="public-download-bar2"
								src="@comm/images/document-conversion/android-download.png" />
						</div>
						<div class="info">Android</div>
						<div>
							<a class="public-download">下载</a>
						</div>
					</div>
				</div>
			</div>
			<div class="item5">
				<!-- <img src="@comm/images/document-conversion/fa.png" style="position: absolute;right: 15%;top: 28px;"> -->
				<img src="@comm/images/document-conversion/fa-.jpg" />
				<div class="item">
					<div class="title">助力企业快速</div>
					<div class="stitle">高效生成电子发票</div>
					<div class="ptitle">根据国家增值税电子发票的标准规范要求，快速、高效地生成OFD电子发票</div>
				</div>
			</div>
		</div>

		<a id="business" class="zhanwei"></a>
		<div class="business">
			<div class="item">
				<div class="title">企业应用</div>
			</div>
			<div class="item item2">
				<div class="title">数科网维OFD电子发票支撑平台的主要核心模块</div>
				<div class="stitle">为电子发票提供全流程的OFD文件处理应用支撑，包括发票制作、加工、查阅、 验证、数据提取等功能，保障电子发票的真实性、</div>
				<div class="stitle">完整性、安全性和可用性，真正满足信息化管理和数据利用要求。</div>
			</div>
			<div class="item item2 item3">
				<div class="business-left">
					<div class="business_title">
						<div class="pic">
							<img src="@comm/images/document-conversion/sdk1.svg" />
						</div>
						<div style="float: left">
							<p class="p_title">电子发票验证SDK</p>
							<p class="p_stitle">提供电子发票的真伪验证功能，通过签名比对、证书查验、有效期验证等手段，全方位验证其真伪性。</p>
							<!-- <p style="margin-bottom: 0;font-size: 14px;color: #999;line-height: 30px;width: 330px;">提供OFD版式电子发票制作生成，发票文件二次加工等功能。</p> -->
						</div>
					</div>
					<div class="business_title">
						<div class="pic">
							<img src="@comm/images/document-conversion/sdk.svg" />
						</div>
						<div style="float: left">
							<p class="p_title">电子发票解析SDK</p>
							<p class="p_stitle">提供多类接口， 实现对发票文件的再利用，包括发票文件格式解析、发票内容提取、全文检索、语义检索、元数据检索等支持能力。</p>
							<!-- <p style="margin-bottom: 0;font-size: 14px;color: #999;line-height: 30px;width: 330px;">提供多类接口， 实现对发票文件的再利用，包括发票文件格式解析、发票内容提取、全文检索、语义检索、元数据检索等支持能力。</p> -->
						</div>
					</div>
					<div class="business_title">
						<div class="pic">
							<img src="@comm/images/document-conversion/sdk3.svg" />
						</div>
						<div style="float: left">
							<p class="p_title">电子发票转换SDK</p>
							<p class="p_stitle">提供OFD电子发票转换为PDF、图片、XML等格式的功能，方便用户二次利用。</p>
							<!-- <p style="margin-bottom: 0;font-size: 14px;color: #999;line-height: 30px;width: 330px;">提供OFD电子发票转换为PDF、图片、XML等格式的功能，方便用户二次利用。</p> -->
						</div>
					</div>
				</div>
				<div class="business-right">
					<div class="business_title">
						<div class="pic">
							<img src="@comm/images/document-conversion/sdk4.svg" />
						</div>
						<div style="float: left">
							<p class="p_title">电子发票模板设计子系统</p>
							<!-- <p style="margin: 21px 0 24px;font-size: 20px;color: #333;">电子发票验证子系统</p> -->
							<p class="p_stitle">支持通过可视化交互的方式设计与纸质发票版面效果完全一致的电子发票模板文件。</p>
							<!-- <p style="margin-bottom: 0;font-size: 14px;color: #999;line-height: 30px;width: 330px;">提供电子发票的真伪验证功能，通过签名比对、证书查验、有效期验证等手段，全方位验证其真伪性。</p> -->
						</div>
					</div>
					<div class="business_title">
						<div class="pic">
							<img src="@comm/images/document-conversion/sdk5.svg" />
						</div>
						<div style="float: left">
							<p class="p_title">电子发票网页发布子系统</p>
							<!-- <p style="margin: 21px 0 24px;font-size: 20px;color: #333;">电子发票网页发布子系统</p> -->
							<p class="p_stitle">无插件阅读功能，可将电子发票转换为HTML网页格式，从而实现发票文件跨平台以及浏览器无插件阅读。</p>
							<!-- <p style="margin-bottom: 0;font-size: 14px;color: #999;line-height: 30px;width: 330px;">无插件阅读功能，可将电子发票转换为HTML网页格式，从而实现发票文件跨平台以及浏览器无插件阅读。</p> -->
						</div>
					</div>
					<div class="business_title">
						<div class="pic">
							<img src="@comm/images/document-conversion/sdk6.svg" />
						</div>
						<div style="float: left">
							<p class="p_title">电子发票制作加工子系统</p>
							<!-- <p style="margin: 21px 0 24px;font-size: 20px;color: #333;">电子发票模板子系统</p> -->
							<p class="p_stitle">提供OFD版式电子发票制作生成，发票文件二次加工等功能。</p>
							<!-- <p style="margin-bottom: 0;font-size: 14px;color: #999;line-height: 30px;width: 330px;">支持通过可视化交互的方式设计与纸质发票版面效果完全一致的电子发票模板文件。</p> -->
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="product">
			<div class="item">
				<div class="title">产品特点</div>
			</div>
			<div class="item item2">
				<div class="item2_fonts">
					<div class="fonts">
						<span>总局官方开票应用软件</span>
						<img src="@comm/images/document-conversion/ak1_1.jpg" style="left: 0; right: auto" />
						<img src="@comm/images/document-conversion/ak1_2.jpg" style="right: 0; left: auto" />
					</div>
				</div>
				<div class="item2_fonts">
					<div class="fonts">
						<span>国家专项课题科研成果</span>
						<img src="@comm/images/document-conversion/ak2_1.jpg" style="left: 0; right: auto" />
						<img src="@comm/images/document-conversion/ak2_2.jpg" style="right: 0; left: auto" />
					</div>
				</div>
			</div>
			<div class="item">
				<div class="subtit-con">
					<div class="subtit-item">
						<div class="subtit-item-ico">
							<img src="@comm/images/document-conversion/back4.svg" />
						</div>
						<div class="subtit-item-tit">全面符合电子发票标准规范</div>
					</div>
					<div class="subtit-item">
						<div class="subtit-item-ico">
							<img src="@comm/images/document-conversion/back5.svg" />
						</div>
						<div class="subtit-item-tit">电子发票文件应用全流程支撑</div>
					</div>
					<div class="subtit-item">
						<div class="subtit-item-ico">
							<img src="@comm/images/document-conversion/back6.svg" />
						</div>
						<div class="subtit-item-tit">海量电子发票高并发极速处理</div>
					</div>
					<div class="subtit-item">
						<div class="subtit-item-ico">
							<img src="@comm/images/document-conversion/back7.svg" />
						</div>
						<div class="subtit-item-tit">接口清晰，集成对接方便快捷</div>
					</div>
				</div>
			</div>
		</div>

		<div class="version">
			<div class="item">
				<div class="title">产品版本</div>
			</div>
			<div class="item item2">
				<div class="pic">
					<img src="@comm/images/document-conversion/table.svg" width="100%" height="100%" />
				</div>
			</div>
			<div class="item item3">
				<div class="item">
					<div class="anchor">
						<a @click.prevent="anchor('public')">个人服务</a>
						<a @click.prevent="anchor('business')">企业应用</a>
					</div>
					<div class="anchor_title">
						<div class="title">
							<img src="@comm/images/document-conversion/phone--.svg" />
							<span>电 话：400-677-5005</span>
						</div>
						<div class="title">
							<img src="@comm/images/document-conversion/mail--.svg" />
							<span>邮 箱：wps@wps.cn</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="footer">
			<div class="item">
				<div style="float: left">
					<div class="pic">
						<img src="@comm/images/document-conversion/account.png" />
					</div>
					<div class="title">
						<p>关注数科网维公众号</p>
						<p class="stitle">您将成为最早知道功能上线的人</p>
					</div>
				</div>
				<div class="right">
					<div class="title">
						<span>数科电子发票阅读器 免费下载：</span>
						<div class="fonts" style="display: inline-block; position: relative">
							<a @click="goDown(1)" class="subtit-upload">
								<img src="@comm/images/document-conversion/win.svg" />
								<span>&nbsp;Windows</span>&emsp;
							</a>
						</div>
						<div class="fonts">
							<a class="subtit-upload subtit-ios-handle">
								<img src="@comm/images/document-conversion/io.svg" />
								<span>&nbsp;App Store</span>&emsp;
							</a>
							<div class="subtit-ios-bar">
								<img src="@comm/images/document-conversion/ios-download.png" />
								<p>扫描二维码</p>
							</div>
						</div>
						<div class="fonts">
							<a class="subtit-upload subtit-android-handle">
								<img src="@comm/images/document-conversion/an.svg" />
								<span>&nbsp;Android</span>&emsp;
							</a>
							<div class="subtit-android-bar">
								<img src="@comm/images/document-conversion/android-download.png" />
								<p>扫描二维码</p>
							</div>
						</div>
					</div>
				</div>
				<div style="clear: both"></div>
			</div>
			<div class="bottom"><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
					style="color: #fff">备案号：京ICP备16014466号</a></div>
		</div>

		<!-- invoiceDialog -->
		<el-dialog :visible.sync="invoiceDialog" width="600px" custom-class="invoiceDialog" :close-on-click-modal="true"
			:append-to-body="true">
			<p slot="title" class="dialogTitle">OFD增值税电子普通发票</p>
			<div class="dialogContainer">
				<div class="send contBox">
					<div>
						<div class="label">开票方：</div>
						<div class="con">{{ content.Seller?content.Seller.sellerName:'' }}</div>
					</div>
					<div>
						<div class="label">纳税人识别号：</div>
						<div class="con">{{ content.Seller?content.Seller.sellerTaxID:'' }}</div>
					</div>
					<div>
						<div class="label">地址/电话：</div>
						<div class="con">
							{{ content.Seller?content.Seller.sellerAddrTel:'' }}
						</div>
					</div>
					<div>
						<div class="label">开户行账号：</div>
						<div class="con">{{ content.Seller?content.Seller.sellerFinancialAccount:'' }}</div>
					</div>
				</div>
				<div class="receive contBox">
					<div>
						<div class="label">收票方：</div>
						<div class="con">{{ content.Buyer?content.Buyer.buyerName:'' }}</div>
					</div>
					<div>
						<div class="label">纳税人识别号：</div>
						<div class="con">{{ content.Buyer?content.Buyer.buyerTaxID:'' }}</div>
					</div>
					<div>
						<div class="label">地址/电话：</div>
						<div class="con">{{ content.Buyer?content.Buyer.buyerAddrTel:'' }}</div>
					</div>
					<div>
						<div class="label">开户行账号：</div>
						<div class="con">
							{{ content.Buyer?content.Buyer.buyerFinancialAccount:'' }}
						</div>
					</div>
				</div>
				<div class="other contBox">
					<div>
						<div class="label">开票日期：</div>
						<div class="con">{{ content.IssueDate }}</div>
					</div>
					<div>
						<div class="label">开票金额：</div>
						<div class="con"></div>
					</div>
					<div>
						<div class="label">大写：</div>
						<div class="con">{{ content.TaxInclusiveTotalAmountUp }}</div>
					</div>
					<div>
						<div class="label">小写：</div>
						<div class="con">{{ content.TaxInclusiveTotalAmount }}</div>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialogFooter">
				<el-button size="small" type="primary" @click="saveHtml">另存为XML</el-button>
				<el-button size="small" @click="invoiceDialog = false">关闭</el-button>
			</div>
		</el-dialog>

		<!-- invDetailDialog -->
		<el-dialog :visible.sync="invDetailDialog" width="600px" custom-class="invoiceDialog listQzDialog"
			:close-on-click-modal="false" :append-to-body="true" :before-close="closedBtn">
			<p slot="title" class="detailTitle"><a :title="fileName">{{ fileName | limitFileName(20) }}</a></p>
			<div class="list_qz" v-if="verifyResult.length > 1">
				<div class="item" v-for="(item, index) in verifyResult" :key="index" @click="handleClick(item.index,index)"
					:class="{ active: activeName == index }">
					<img :src="item.img" alt="" class="qz_icon" /> <a :title="item.name">{{ item.name }}</a>
				</div>
			</div>
			<div class="detailContainer">
				<div class="wrap-note-detail"
					v-if="verifyInfo.result == 0 || (verifyInfo.result >= '0X00000900' && verifyInfo.result <= '0X000009FF')">
					<div class="wrap-ico-detail">
						<img src="@comm/images/document-conversion/ok.svg" alt="" />
					</div>
					<div class="wrap-txt-detail">
						<p class="wrap-txt-tit">发票签章有效！
							<el-tooltip :content="verifyInfo.message" placement="bottom-start" v-if="verifyInfo.message"
								effect="light">
								<img src="@comm/images/document-conversion/warning_icon.png" class="warning_icon" />
							</el-tooltip>
						</p>
						<p class="wrap-txt-note">受发票签章保护的文档内容未被修改。该签章之后的文档内容无变更。</p>
					</div>
				</div>
				<div class="wrap-unknown-detail" v-else-if="verifyInfo.result == '0X00000100'">
					<div class="wrap-ico-detail">
						<img src="@comm/images/document-conversion/unknown.svg" alt="" />
					</div>
					<div class="wrap-txt-detail">
						<p class="wrap-txt-tit">发票签章有效性未知！</p>
						<p class="wrap-txt-note">签章无法验证。</p>
					</div>
				</div>
				<div class="wrap-err-detail" v-else>
					<div class="wrap-ico-detail">
						<img src="@comm/images/document-conversion/no.svg" alt="" />
					</div>
					<div class="wrap-txt-detail">
						<p class="wrap-txt-tit">发票签章无效！</p>
						<p class="wrap-txt-note">签章验证有误。</p>
					</div>
				</div>
				<div class="wrap-label-detail">
					<p class="label-detail">签章信息</p>
					<p>
						<span class="label-name">签章人：</span><span class="label-content CommonName">{{
								verifyInfo.CommonName
						}}</span>
					</p>
					<p>
						<span class="label-name">签章时间：</span><span class="label-content SignTime">{{ verifyInfo.SignTime
						}}</span>
					</p>
				</div>
				<div class="wrap-label-detail">
					<p class="label-detail">印章信息</p>
					<p>
						<span class="label-name">印章名称：</span><span class="label-content SealName">{{ verifyInfo.SealName
						}}</span>
					</p>
					<p>
						<span class="label-name">有效起止时间：</span><span class="label-content SealValid">{{
								verifyInfo.SealValidStart + "\xa0\xa0-\xa0\xa0" +
								verifyInfo.SealValidEnd
						}}</span>
					</p>
				</div>
				<p class="label-detail" style="color: #333">本次验签使用默认签章库</p>
				<div class="dialog-footer">
					<el-button size="small" @click="closedBtn">关闭</el-button>
				</div>
			</div>
		</el-dialog>

		<!-- bootstrap modal -->
		<div class="modal fade" tabindex="-1" id="myModal_loading" v-if="isUpLoading">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<img src="@comm/images/document-conversion/loading.gif" alt="上传中。。。" />
				</div>
			</div>
		</div>
		<!-- <el-dialog :visible.sync="invoiceDialog" width="600px" custom-class="invoiceDialog" :close-on-click-modal="true" :append-to-body="true">
			<p slot="title" class="dialogTitle">OFD增值税电子普通发票</p>
			<div class="dialogContainer"></div>
		</el-dialog> -->

		<form method="post" enctype="multipart/form-data" style="display: none">
			<input type="file" name="file" />
		</form>
		<customer-service></customer-service>
	</div>
</template>

<script>
import { Base64 } from "js-base64";
import { ACCEPT_CONFIG } from "@comm/utils/acceptFileType.js";
import { downPcReader } from "@comm/api/document-conversion";
import headNav from "@comm/components/document-conversion/headerPage";
import customerService from "@comm/components/document-conversion/customerService";
import { buriedPoint } from "@comm/utils/buryingPoint.js";
import { invoiceUpload, invoiceInfo, downloadPdf, downloadJpg } from "@comm/api/document-conversion";
import common from "@comm/utils/common";
import { saveAs } from "file-saver";
import $ from "jquery";
import { getToken } from "@comm/utils/auth";
export default {
	metaInfo: {
		title: '数科OFD电子发票在线使用平台，多项实用功能处理OFD发票',
		meta: [
			{
				name: 'keywords',
				content: 'OFD、OFD发票、打开OFD发票、OFD发票转换、发票查验、发票提取'
			},
			{
				name: 'description',
				content: '数科OFD电子发票一站式服务平台，支持浏览器无插件阅读，在线格式转换为PDF/图片，自动验证发票真伪，提取发票数据等功能。'
			}
		]
	},
	name: "invoicePage",
	components: { headNav, customerService },
	data() {
		return {
			isPhone: false,
			options: {
				target: "invoice-info/upload",
				chunkSize: "2048000",
				fileParameterName: "upfile",
				maxChunkRetries: 1,
				testChunks: false,
				allowDuplicateUploads: true,
				headers: {
					// Authorization: getToken(),
				},
				query() { }
			},
			attrs: {
				accept: ACCEPT_CONFIG.getOfd()
			},
			disabled: true,
			SignInfo: [],
			content: {},
			verifyResult: [],
			isUpLoading: false,
			readerUrl: "",
			fileId: "",
			fileSize: 0,
			downTime: 0,
			fileName: "",
			isDragenter: false,
			winLink: "",
			andLink: "",
			timer: null,
			invoiceDialog: false,
			invDetailDialog: false,
			token: null,
			activeName: 0,
			verifyInfo: {
				result: '',
				message: '',
				SignTime: '',
				SealName: '',
				SealValidStart: '',
				SealValidEnd: '',
				CommonName: ''
			},
		};
	},
	created() {
		this.andLink = localStorage.andLink;
		this.winLink = localStorage.winLink;
		this.isPhone = localStorage.getItem("isPhone");
		document.title = "电子发票";
		this.$nextTick(() => {
			this.toLocal();
		});
	},
	mounted() {
		this.token = getToken()
		$(".subtit-android-handle").mouseenter(function () {
			$(".subtit-android-bar").fadeIn();
		});
		$(".subtit-android-handle").mouseleave(function () {
			$(".subtit-android-bar").fadeOut();
		});
		$(".subtit-ios-handle").mouseenter(function () {
			$(".subtit-ios-bar").fadeIn();
		});
		$(".subtit-ios-handle").mouseleave(function () {
			$(".subtit-ios-bar").fadeOut();
		});
		// ==========================================
		$(".public-download-handle-").mouseenter(function () {
			$(this).find(".public-download-bar1").hide();
			$(this).find(".public-download-bar2").show();
		});
		$(".public-download-handle-").mouseleave(function () {
			$(this).find(".public-download-bar1").show();
			$(this).find(".public-download-bar2").hide();
		});
		$("#feedback").click(function () {
			$(this).toggleClass("fdout").toggleClass("fdin");
		});
		let _this = this;
		_this.$nextTick(function () {
			window.addEventListener("scroll", _this.handleScroll);
		});
		document.body.ondrop = function(event){
			event.preventDefault();
			event.stopPropagation();
		}
	},
	watch: {
		//监听相同路由下参数变化的时候，从而实现异步刷新
		$route(to, from) {
			this.$router.go(0);

		},
	},
	destroyed() {
		localStorage.setItem("toId", "");
	},
	methods: {
		closedBtn() {
			this.invDetailDialog = false
		},
		handleClick(index,indexs) {
			this.activeName = indexs
			let data = this.SignInfo[index]
			let Issuerinfo = data.sealCert.issuerInfo
			let result = this.verifyResult[indexs]
			this.verifyInfo = {
				result: result.code,
				message: result.message,
				SignTime: data.timeInfo,
				SealName: data.sealName,
				SealValidStart: data.validStart,
				SealValidEnd: data.validEnd,
				CommonName: Issuerinfo.commonName
			}
		},
		getUserToken(data) {
			this.token = data.token
		},
		// 发票element dialog
		viewInvoice() {
			this.invoiceDialog = true;
			this.buriedPointBtn("btn", 130);
		},
		viewDetail() {
			this.invDetailDialog = true;
			this.buriedPointBtn("btn", 129);
		},
		goDown(type) {
			if (this.timer) clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				if (type == 1) {
					downPcReader({ dictionaryId: "135" })
						.then((res) => { })
						.catch(() => { });
				}
				window.open(type == 1 ? localStorage.winLink : localStorage.andLink, "_self");
			}, 300);
		},
		toLocal() {
			//查找存储的锚点id
			let Id = localStorage.getItem("toId");
			let toElement = document.getElementById(Id);
			//锚点存在跳转
			if (Id) {
				toElement.scrollIntoView();
			}
		},
		/*锚链接跳转*/
		anchor(anchorName) {
			/*找到锚点*/
			let anchorElement = document.getElementById(anchorName);
			/*如果对应id的锚点存在，就跳转到锚点*/
			if (anchorElement) {
				anchorElement.scrollIntoView();
			}
		},
		buriedPointBtn(type, id) {
			setTimeout(function () {
				buriedPoint(type, id);
			}, 200);
		},
		dragenter() {
			this.isDragenter = true;
		},
		loginBtn() {
			let path = this.$route.path;
			window.open(
				`https://openapi.wps.cn/oauthapi/v2/authorize?response_type=code&appid=AK20211015RYLLFO&autologin=false&redirect_uri=${common.readCodeUrl}${path}&scope=user_info&state=STATE`,
				"_self"
			);
		},
		onFileAdded(file) { },
		onSubmitted(fileList) {
			if (fileList.length <= 0) {
				return;
			}
			if (fileList.length > 1) {
				this.$confirm("该功能仅支持单文件操作", "", {
					cancelButtonText: "取消",
					confirmButtonText: "确定",
					showCancelButton: false,
					type: "warning"
				}).then(() => {
					return;
				});
				return;
			} else {
				this.fileSize = fileList[0].size;
				const isLt = this.fileSize / 1024 / 1024 / 5 <= 1;
				if (!isLt) {
					this.$message.error("上传文件大小不得大于5MB!");
					return;
				}
			}
			let clickType = this.isDragenter ? 1 : 0;
			let dictionaryId = this.isDragenter ? 123 : 124;
			this.isDragenter = false;
			setTimeout(function () {
				buriedPoint("isUpload", dictionaryId, clickType);
			}, 200);
			let fileData = new FormData();
			fileData.append("file", fileList[0].file);
			fileData.append("dictionaryId", 125);
			this.readerUrl = "";
			this.disabled = true;
			this.isUpLoading = true;

			invoiceUpload(fileData)
				.then((res) => {
					if (!res.data) {
						this.isUpLoading = false;
						return;
					}

					this.isUpLoading = false;
					this.disabled = false;
					this.activeName = 0;
					this.fileId = res.data.fileId;
					this.fileName = res.data.fileName;
					this.readerUrl = `${common.readCodeUrl}/readering:${this.fileId}`;
					this.content = res.data.content;
					this.SignInfo = res.data.SignInfo
					let verifyResult = res.data.VerifyResult
					let verifyResultData = []
					verifyResult.forEach((item, index) => {
						item.name = this.SignInfo[index].sealName
						item.img = "data:image/png;base64," +this.SignInfo[index].sealImage.pictureData;
						item.type = this.SignInfo[index].type
						item.index=index
						if (item.type != 'TimeStamp') {
							verifyResultData.push(item)
						}
					})
					this.verifyResult = verifyResultData
					let data=null
					let Issuerinfo=null
					if(res.data.SignInfo.length>0){
						data = res.data.SignInfo[0]
					    Issuerinfo = data.sealCert.issuerInfo
					}
					
					let result = res.data.VerifyResult.length>0?res.data.VerifyResult[0]:null
					this.verifyInfo = {
						result: result?result.code:-4,
						message: result?result.message:'',
						SignTime: data?data.timeInfo:'',
						SealName: data?data.sealName:'',
						SealValidStart: data?data.validStart:'',
						SealValidEnd: data?data.validEnd:'',
						CommonName: Issuerinfo?Issuerinfo.commonName:''
					}

				})
				.catch(() => {
					this.isUpLoading = false;
				});
		},
		//另存为xml
		saveHtml() {
			invoiceInfo({ fileId: this.fileId }).then((res) => {
				this.downloadFile(1, res);
			});
		},
		//下载pdf
		savePdf() {
			this.downTime = Date.parse(new Date());
			downloadPdf({
				fileId: this.fileId,
				dictionaryId: 126
			})
				.then((res) => {
					this.downloadFile(2, res);
				})
				.catch((err) => {
					let nowTime = Date.parse(new Date());
					let time = nowTime - this.downTime;
					setTimeout(function () {
						buriedPoint("isDown", 128, 1, 0, 1, time, this.fileSize);
					}, 200);
				});
		},
		//下载jpg
		saveJpg() {
			this.downTime = Date.parse(new Date());
			downloadJpg({
				fileId: this.fileId,
				dictionaryId: 126
			})
				.then((res) => {
					this.downloadFile(3, res);
				})
				.catch((err) => {
					let nowTime = Date.parse(new Date());
					let time = nowTime - this.downTime;
					setTimeout(function () {
						buriedPoint("isDown", 128, 1, 0, 3, time, this.fileSize);
					}, 200);
				});
		},
		downloadFile(type, res) {
			if (!res) {
				this.$message.error("下载文件失败");
				return false;
			}
			let filename = "";
			if (type == 1) {
				filename = "original_invoice.xml";
			} else if (type == 2) {
				filename = res.headers["filename"];
			} else {
				filename = res.headers["filename"];
			}
			const blob = new Blob([res.data]);
			if (sessionStorage.getItem("browserType") == "IE") {
				saveAs(blob, filename);
			} else {
				const downloadElement = document.createElement("a");
				const href = window.URL.createObjectURL(blob); //创建下载的链接
				downloadElement.href = href;
				downloadElement.download = decodeURIComponent(filename);
				document.body.appendChild(downloadElement);
				downloadElement.click(); //点击下载
				document.body.removeChild(downloadElement); //下载完成移除元素
				window.URL.revokeObjectURL(href); //释放blob对象
				let dictionaryId = 0;
				let downloadFileType = 0;
				if (type == 1) {
					setTimeout(function () {
						buriedPoint("btn", 131);
					}, 200);
				} else if (type == 2) {
					downloadFileType = 1;
					dictionaryId = 128;
				} else {
					downloadFileType = 3;
					dictionaryId = 128;
				}
				if (type == 2 || type == 3) {
					let nowTime = Date.parse(new Date());
					let time = nowTime - this.downTime;
					setTimeout(function () {
						buriedPoint("isDown", dictionaryId, 0, 0, downloadFileType, time, this.fileSize);
					}, 200);
				}
			}
		},
		// 打印
		printBth() {
			this.$refs.iframe.contentWindow.postMessage(["click", "print"], "*");
		}
	}
};
</script>
<style lang="scss" scoped>
.footer .right {
	.fonts {
		img {
			width: 20px;
			height: 20px;
		}
	}
}

.readpage_top {
	height: 44px;
	background: #f5f5f5;
	padding: 0 15px 0 10px;
	border-bottom: 1px solid #eaeaea;
	display: flex;
	align-items: center;
	justify-content: space-between;

	.left {
		font-size: 14px;
		color: #000000;
		display: flex;
		align-items: center;

		img {
			display: inline-block;
			width: 32px;
			height: 32px;
			margin-right: 6px;
			vertical-align: middle;
		}
	}

	.right {
		font-size: 12px;
		color: #333333;
		display: flex;
		align-items: center;

		.item {
			margin-left: 15px;
			width: auto;
			padding: 5px 0;

			&:hover {
				cursor: pointer;
				background: #e4e4e4;
				border-radius: 2px;
			}
		}

		span {
			display: inline-block;
			width: 24px;
			height: 24px;
			margin-right: 5px;
			vertical-align: middle;

			&.down_icon {
				background: url("../../comm/images/document-conversion/zxyl/down_btn.png") 0 0 no-repeat;
				background-size: 100%;
			}

			&.dy_icon {
				background: url("../../comm/images/document-conversion/zxyl/dy_icon.png") 0 0 no-repeat;
				background-size: 100%;
			}

			&.share_icon {
				background: url("../../comm/images/document-conversion/zxyl/share_icon.png") 0 0 no-repeat;
				background-size: 100%;
			}

			&.phone_icon {
				background: url("../../comm/images/document-conversion/zxyl/phone_icon.png") 0 0 no-repeat;
				background-size: 100%;
			}
		}
	}
}
</style>

<style lang="scss">
.invoiceDialog {
	.wrap-label-detail {
		p {
			display: flex;
		}

		.label-name {
			text-align: left;
			width: 100px;
		}

		.label-content {
			flex: 1;
		}
	}

	.detailContainer {
		flex: 1;
		padding: 0 25px;

		.dialog-footer {
			float: right;
			margin-top: 50px;
		}
	}

	.el-dialog__header {
		padding: 0;
	}

	.dialogTitle {
		padding: 18px 24px;
		position: relative;
	}

	.dialogTitle::after {
		display: block;
		content: "";
		position: absolute;
		left: 0;
		bottom: 0;
		height: 1px;
		width: 100%;
		background-color: #e5e5e5;
	}

	.detailTitle {
		padding: 18px 24px;
		border-bottom: 1px solid #e5e5e5;
	}

	.el-dialog__body {
		padding: 0;
	}

	.contBox {
		width: 100%;
		overflow: auto;
		line-height: 22px;
		font-size: 12px;
		padding: 18px 24px;

		&>div {
			width: 100%;
		}

		div {
			overflow: auto;
			display: flex;
			&.con{
				flex: 1;
			}
		}
	}

	.receive {
		background-color: #f7f7f7;
	}

	.label {
		width: 110px;
		height: 22px;
		color: #aaa;
		text-align: right;
	}

	.detailContainer {
		padding: 24px 20px;
		line-height: 24px;
		overflow: auto;
	}

	&.listQzDialog {
		.el-dialog__body {
			display: flex;
			align-items: flex-start;
		}

		.qz_icon {
			width: 24px;
			vertical-align: middle;
			margin-right: 6px;
		}
	}
}
</style>
 



// WEBPACK FOOTER //
// src/supubwps-document-conversion/pages/InApplication.vue